// extracted by mini-css-extract-plugin
export default {"tabs":"GroupsModal_tabs__JV1vn","title":"GroupsModal_title__DeO60","modal":"GroupsModal_modal__PiP40"};